export function formatDate(
  date: string | Date,
  options?: Intl.DateTimeFormatOptions
) {
  const formatter = new Intl.DateTimeFormat('en', options)
  return formatter.format(new Date(date))
}

export function addDaysToTodayFormatted(days: number) {
  let result = new Date(Date.now())
  result.setDate(result.getDate() + days)

  return formatDate(result, {
    dateStyle: 'medium',
  })
}

export const DATE_FORMATS = {
  month: {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  },
  shortmonth: {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  },
  twodigitmonth: {
    month: '2-digit',
    day: 'numeric',
    year: 'numeric',
  },
  '12_hours': {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  },
  '24_hours': {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  },
  // we can always add more options here as the cases come up
} as const

export function parsePresaleDate(dateInput: string | Date) {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const date = new Date(dateInput) // coerce input as a Date object
  const currentYear = new Date().getFullYear()
  const day = date.getDate()
  const hour = date.getHours()
  const minutes = date.getMinutes()

  const today = new Date()
  const tomorrow = new Date()
  tomorrow.setDate(today.getDate() + 1)

  // Determine ordinal suffix
  const suffix =
    day % 10 === 1 && day !== 11
      ? 'st'
      : day % 10 === 2 && day !== 12
        ? 'nd'
        : day % 10 === 3 && day !== 13
          ? 'rd'
          : 'th'

  const formattedHour = hour < 10 ? `0${hour}` : hour
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes
  let formattedDate = `${months[date.getMonth()]} ${day}${suffix}`

  if (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  ) {
    formattedDate = 'Today'
  }

  if (
    date.getFullYear() === tomorrow.getFullYear() &&
    date.getMonth() === tomorrow.getMonth() &&
    date.getDate() === tomorrow.getDate()
  ) {
    formattedDate = 'Tomorrow'
  }

  return {
    date:
      date.getFullYear() === currentYear
        ? `${formattedDate}`
        : `${formattedDate} ${date.getFullYear()}`,
    time: `${formattedHour}h${formattedMinutes}`,
  }
}

export const isTodayOrTomorrow = (dateInput: string | Date): boolean => {
  const date = new Date(dateInput) // coerce input as a Date object

  const today = new Date()
  const tomorrow = new Date()
  tomorrow.setDate(today.getDate() + 1)

  // Check if the passed input date is today or tomorrow
  return (
    (date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()) ||
    (date.getFullYear() === tomorrow.getFullYear() &&
      date.getMonth() === tomorrow.getMonth() &&
      date.getDate() === tomorrow.getDate())
  )
}

export const getTomorrowDate = (): Date => {
  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)
  return tomorrow
}
